import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalize, Observable, of, share, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SvgService {
  public readonly loadedSvgElement: Map<string, string> = new Map();
  public readonly loadingSvgElement: Map<string, Observable<string>> =
    new Map();

  private readonly httpClient: HttpClient = inject(HttpClient);

  // keyed by url: the response only depends on the path, so every b2cSvg
  // instance asking for the same asset shares one request. Callers apply
  // their own fill/stroke/width to their own copy of the text (EAI-2182)
  public fetch(url: string): Observable<string> {
    if (this.loadedSvgElement.has(url)) {
      return of(<string>this.loadedSvgElement.get(url));
    }

    if (this.loadingSvgElement.has(url)) {
      return <Observable<string>>this.loadingSvgElement.get(url);
    }

    const svgObs: Observable<string> = this.httpClient
      .get(url, { responseType: 'text' })
      .pipe(
        tap((svgText: string) => this.loadedSvgElement.set(url, svgText)),
        finalize(() => this.loadingSvgElement.delete(url)),
        share()
      );

    this.loadingSvgElement.set(url, svgObs);
    return svgObs;
  }
}
